export default __webpack_public_path__ + "static/media/Attributes.e11e8b34.svg";